import { apiClient } from "./api";

/**
 * Fetch data from cache with fallback to API
 * @param {Object} options - Options for fetching data
 * @param {string} options.viewType - View type (Prototype, VFF, Both)
 * @param {number} options.page - Page number
 * @param {number} options.itemsPerPage - Items per page
 * @returns {Promise<Object>} - Promise resolving to data object
 */
export const fetchCachedData = async ({
	viewType = "Prototype",
	page = 1,
	itemsPerPage = 25,
}) => {
	try {
		console.log(
			`Fetching cached data for ${viewType} (page=${page}, items=${itemsPerPage})`,
		);

		// Try to get data from filtered cache endpoint
		console.log("Attempting to fetch from cached-data endpoint...", apiClient);
		const response = await apiClient.get("/api/cached-data", {
			params: {
				view_type: viewType,
				page,
				items_per_page: itemsPerPage,
			},
		});

		console.log(`✅ Successfully fetched cached data for ${viewType}`);
		return response.data;
	} catch (error) {
		console.error("Error fetching cached data:", error);

		// If cache fails, fall back to filtered-data API
		console.log("Falling back to filtered-data API...");
		const fallbackResponse = await apiClient.post("/api/filtered-data", {
			view_type: viewType,
			page,
			items_per_page: itemsPerPage,
			// No filters for initial load
			project: [],
			programm: [],
			purchase_type: [],
			se_teams: [],
			gx_classification: [],
			ramp_up_group: [],
			search: "",
		});

		return fallbackResponse.data;
	}
};

/**
 * Fetch filter options from cache with fallback to API
 * @param {string} viewType - View type (Prototype, VFF, Both)
 * @returns {Promise<Object>} - Promise resolving to filter options object
 */
export const fetchCachedFilterOptions = async (viewType = "Prototype") => {
	try {
		console.log(`Fetching cached filter options for ${viewType}`);

		// Try to get filter options from cache
		const response = await apiClient.get("/api/filter-options", {
			params: {
				view_type: viewType,
				use_cache: true,
			},
		});

		console.log(
			`✅ Successfully fetched cached filter options for ${viewType}`,
		);
		return response.data;
	} catch (error) {
		console.error("Error fetching cached filter options:", error);
		throw error;
	}
};
